import { render, staticRenderFns } from "./whatsappBot.vue?vue&type=template&id=058fe6ea&scoped=true&"
import script from "./whatsappBot.vue?vue&type=script&lang=js&"
export * from "./whatsappBot.vue?vue&type=script&lang=js&"
import style0 from "./whatsappBot.vue?vue&type=style&index=0&id=058fe6ea&lang=scss&scoped=true&"
import style1 from "./whatsappBot.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./whatsappBot.vue?vue&type=style&index=2&id=058fe6ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058fe6ea",
  null
  
)

export default component.exports